<lib-page-layout>
  <lib-title-navbar pageHeader title="Wiadomości"></lib-title-navbar>

  <div pageHeader>
    <div class="chats-search-container or-px-16-px or-py-12-px">
      <div class="chats-search-field">
        <or-input-with-icon
          class="chats-search-input"
          placeholder="Szukaj"
          icon="assets/icons/search-icon.svg"
          [formControl]="searchControl" />
      </div>
    </div>
  </div>

  <div class="chats-list-divider"></div>

  @if (isLoading()) {
    <or-list-skeleton [elements]="6"></or-list-skeleton>
  } @else if (isChatAvailable() && channels()?.length) {
    @for (channel of channels(); track trackByChannelId($index, channel)) {
      <lib-channel-list-item
        [channel]="channel"
        [highlightQuery]="searchTerm()"
        [refreshTick]="channelsVersion()"
        (click)="selectChannel(channel)">
      </lib-channel-list-item>
      @if (!$last) {
        <div class="chats-list-divider"></div>
      }
    }
  } @else if (searchTerm()) {
    <div class="or-justify-content-center or-align-items-center or-d-flex or-flex-col or-h-100-pc or-px-32-px">
      <div class="or-text-align-center or-head-lg">Brak wyników.</div>
    </div>
  } @else {
    <div class="or-justify-content-center or-align-items-center or-d-flex or-flex-col or-h-100-pc or-px-32-px">
      <div class="or-text-align-center or-head-lg">Twój chat jest pusty.</div>
    </div>
  }
  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
